export default "/_next/static/chunks/fonts/LarsseitBold-b4463037fe361979b9ae7c896668b92d.ttf";